import { matchPath } from 'react-router-dom';

const SLUG = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

/**
 * Slug → project id pairs revealed by public portfolio responses. Case-study
 * links use canonical slug URLs; visits keep being recorded against the numeric
 * project id, so per-project analytics continue across the URL change.
 */
const slugIds = new Map<string, number>();

/** Remembers the canonical slug of every project a public portfolio response returned. */
export function rememberPortfolioSlugs(projects: ReadonlyArray<{ id: number; slug?: string | null }>): void {
  for (const project of projects) {
    if (!project.slug || !SLUG.test(project.slug) || !Number.isSafeInteger(project.id) || project.id <= 0) continue;
    slugIds.set(project.slug, project.id);
  }
}

/** Portfolio project id whose visit is tracked for the current path (numeric ids and known slugs). */
export function trackedPortfolioProjectId(pathname: string): number | undefined {
  const match = matchPath('/portfolio/:idOrSlug', pathname);
  const segment = match?.params.idOrSlug;
  if (!segment) return undefined;
  if (/^\d+$/.test(segment)) return Number.parseInt(segment, 10);
  return slugIds.get(segment);
}
